export default function NotificationIcon() {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.49999 14V14.625C5.49999 15.288 5.76339 15.9239 6.23223 16.3927C6.70107 16.8616 7.33695 17.125 7.99999 17.125C8.66304 17.125 9.29892 16.8616 9.76776 16.3927C10.2366 15.9239 10.5 15.288 10.5 14.625V14M2.39086 7.12495C2.38982 6.38371 2.53551 5.64959 2.81952 4.96491C3.10352 4.28024 3.52024 3.65854 4.04563 3.13567C4.57103 2.61279 5.19473 2.19907 5.88076 1.91837C6.5668 1.63766 7.30161 1.49551 8.04284 1.50011C11.1358 1.5231 13.6098 4.09396 13.6098 7.19557V7.74995C13.6098 10.548 14.1952 12.1717 14.7108 13.0592C14.7663 13.154 14.7959 13.2618 14.7965 13.3717C14.797 13.4816 14.7686 13.5897 14.7141 13.6851C14.6596 13.7805 14.5809 13.8599 14.4859 13.9151C14.3909 13.9704 14.283 13.9997 14.1731 14H1.82684C1.71694 13.9997 1.60905 13.9704 1.51406 13.9151C1.41908 13.8598 1.34035 13.7805 1.28583 13.685C1.23131 13.5896 1.20292 13.4815 1.20353 13.3716C1.20414 13.2617 1.23372 13.1539 1.28929 13.059C1.80517 12.1716 2.39085 10.5479 2.39085 7.74995L2.39086 7.12495Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
